require("./visualMapContinuous");

require("./visualMapPiecewise");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/visualMap.js
// module id = 522
// module chunks = 0